import { ApisauceInstance, create } from 'apisauce'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import { isAPISuccess } from '@flowwai-frontend/shared/api-common'
import {
   HTTP_ACCEPT_HEADER_VALUE,
   HTTP_CACHE_CONTROL_HEADER_VALUE,
   HTTP_CONTENT_TYPE_HEADER_VALUE,
   HTTP_PRAGMA_HEADER_VALUE
} from '@flowwai-frontend/shared/auth/common'

import { SsoExchangeRequestType, SsoExchangeResponseType } from '../types'
import ssoEndpoints from './ssoEndpoints'
import SsoExchangeService from './'

const SSO_BASE_URL = Config.BACKEND_REST_URL

export class SsoExchangeServiceAPI implements SsoExchangeService {
   api: ApisauceInstance

   constructor() {
      this.api = create({
         baseURL: SSO_BASE_URL,
         headers: {
            'Content-Type': HTTP_CONTENT_TYPE_HEADER_VALUE,
            Accept: HTTP_ACCEPT_HEADER_VALUE,
            Pragma: HTTP_PRAGMA_HEADER_VALUE,
            'Cache-Control': HTTP_CACHE_CONTROL_HEADER_VALUE
         }
      })
   }

   exchangeSsoCode = async (requestObject: SsoExchangeRequestType) => {
      const response = await this.api.post<SsoExchangeResponseType | unknown>(
         ssoEndpoints.exchange,
         requestObject
      )

      if (isAPISuccess(response.status)) return response.data

      throw response.data
   }
}
